export default "__VITE_ASSET__BhaVITDm__"